// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"e60508f1","984":"e60508f1","2080":"e60508f1","2731":"e60508f1","3631":"e60508f1","5316":"e60508f1","6633":"e60508f1","8138":"e60508f1","9033":"e60508f1"}[chunkId] + ".chunk.css";
};